import React from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import styled from 'styled-components';

import BulkSelectToggleButton from 'components/lib/BulkSelectToggleButton';
import Input from 'components/lib/Input';

import { STATUS_FILTER_WIDTH, STATUS_OPTIONS } from './constants';
import { IncentiveScrappingStatusFilter } from './types';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const LeftFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Filters = styled.div`
  display: flex;
  align-items: center;
`;

const StyledSelect = styled(Select)`
  margin-right: 10px;

  &&& {
    .ant-select-selector {
      width: ${STATUS_FILTER_WIDTH}px;
      padding: 0 10px;
      border-radius: 0;
      border: solid 1px var(--line-gray);

      .ant-select-selection-item {
        font-size: 14px;
        padding: 0 !important;
      }
    }

    &:hover,
    &:focus {
      .ant-select-selector {
        border: solid 1px var(--line-gray) !important;
      }
    }
  }
`;

type Props = {
  isMultipleSelection: boolean;
  onToggleMultipleSelection: () => void;
  status: IncentiveScrappingStatusFilter;
  setStatus: (value: IncentiveScrappingStatusFilter) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  setPage: (value: number) => void;
};

const IncentiveScrappingToolbar = ({
  isMultipleSelection,
  onToggleMultipleSelection,
  status,
  setStatus,
  searchTerm,
  setSearchTerm,
  setPage,
}: Props) => (
  <Container>
    <LeftFilters>
      <BulkSelectToggleButton
        active={isMultipleSelection}
        tooltipTitle="Toggle multi select"
        onClick={onToggleMultipleSelection}
      />
    </LeftFilters>
    <Filters>
      <StyledSelect
        options={STATUS_OPTIONS}
        value={status}
        onChange={(value) => {
          setStatus(value as IncentiveScrappingStatusFilter);
          setPage(1);
        }}
        popupMatchSelectWidth={false}
        dropdownStyle={{ width: 'max-content', minWidth: STATUS_FILTER_WIDTH }}
        getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
      />
      <Input
        value={searchTerm}
        prefix={<SearchOutlined />}
        style={{ width: 360 }}
        onChange={(event: any) => {
          setSearchTerm(event.target.value);
          setPage(1);
        }}
        placeholder="Search by company name"
      />
    </Filters>
  </Container>
);

export default IncentiveScrappingToolbar;
